/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Load_MoreInputs */

const en_blog_load_more = /** @type {(inputs: Blog_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

const pl_blog_load_more = /** @type {(inputs: Blog_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż więcej`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Blog_Load_MoreInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_load_more = /** @type {((inputs?: Blog_Load_MoreInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Load_MoreInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_load_more(inputs)
	return en_blog_load_more(inputs)
});